import React from "react";
import ReactDom from "react-dom";
import BaseballCarousel from "./BaseballCarousel";

function BaseballPage() {
  return (
    <div id="BaseballPage" className="baseball-div">
    <br />
      <h1 className="baseball-heading title-heading"> Baseball </h1><hr className="title-hr"/>
      <br />
      <p> I used to play baseball. Now a little washed, my memories as a pitcher for Pomona-Pitzer over 4 years are immortalized on this React carousel :) </p>
      <BaseballCarousel / >
    </div>
  )

}

export default BaseballPage;
